import React from 'react'
import {CurrencyRange} from './currencyRange'

type Props = {
  name: string
  label: string
  value: CurrencyRange
  disabled: boolean
  error?: string
  onChange: (value: CurrencyRange) => void
}

export function CurrencyRangeField({name, label, value, disabled, error, onChange}: Props) {
  return (
    <fieldset className='form-group' style={{border: 0, padding: 0}}>
      <legend className='form-label'>{label}</legend>
      <div style={{display: 'flex', gap: 12}}>
        {(['min', 'max'] as const).map((bound) => (
          <div key={bound} style={{flex: 1, minWidth: 0}}>
            <label htmlFor={`${name}-${bound}`} className='form-label' style={{fontSize: 13}}>
              {bound === 'min' ? 'Mínimo (R$)' : 'Máximo (R$)'}
            </label>
            <input
              id={`${name}-${bound}`}
              className='form-input'
              type='text'
              inputMode='decimal'
              autoComplete='off'
              placeholder='Sem limite'
              disabled={disabled}
              value={value[bound] ?? ''}
              onChange={(event) => onChange({...value, [bound]: event.target.value})}
              aria-invalid={Boolean(error)}
              aria-describedby={error ? `${name}-error` : undefined}
            />
          </div>
        ))}
      </div>
      {error && <span id={`${name}-error`} role='alert' className='text-danger mt-2'>{error}</span>}
    </fieldset>
  )
}
